export default {
    getIsLoadIng: function (state) {
        console.log(state.data + "state.data")
        console.log(state.data)
        if (state.data) {
            return true;
        }
        return false
    },
    getData: function (state) {
        if (state.data) {
            return state.data;
        }
        return undefined
    }
}